export const faqs = [
  {
    question: "公告库里的内容可以引用吗？",
    answer:
      "可以。每篇公告都保留了原文、发布时间与归档编号，引用时建议同时注明编号与日期，便于对方核对。转载时请勿删改原文表述，也不要截取片段单独解读。",
  },
  {
    question: "看到疑似不实信息，怎么提交核实？",
    answer:
      "请通过「联系我们」页面的线索提交入口发起，尽量附上原始链接、截图与传播时间。提交后会生成受理编号，我们会按顺序核查并在公告库同步结论。",
  },
  {
    question: "为什么有些传闻没有被单独立项澄清？",
    answer:
      "我们优先处理已形成一定传播范围、且涉及可核查事实问题的说法。对于明显属于个人主观评价、重复炒作或无法定位原始出处的说法，会合并到相关公告中统一说明。",
  },
  {
    question: "公告的发布时间和最后更新时间有什么区别？",
    answer:
      "发布时间是公告首次对外发布的时间，不会改动；如果后续有补充说明，会在原文下方以「补充」形式追加，并记录更新时间，方便你确认自己看到的是最新版本。",
  },
  {
    question: "收到自称官方客服的联系，应该怎么判断？",
    answer:
      "官方不会索要短信验证码、登录密码或支付密码，也不会要求向个人账户转账。遇到这类联系，请先不要操作，把聊天记录通过线索提交入口发给我们核实。",
  },
  {
    question: "官方会对哪些内容采取处理措施？",
    answer:
      "主要针对涉及个人隐私、伪造材料、冒用官方名义以及对具体主体作出不可核查指控的内容。正常的批评、讨论与负面评价不在处理范围内。",
  },
] as const;